function createAlpha(color, opacity) {
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

function createLinearGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

function createButtonLinearGradient(color1, color2, color3) {
  return `linear-gradient(to bottom, ${color1}, ${color2}, ${color3})`;
}

// SETUP COLORS
const PRIMARY = {
  lighter: "#252733",
  light: "#252733",
  // main: "#3169C8",
  main: "#2F7DFF",
  gradientColor:createLinearGradient("#40B8B3","#2F7DFF"),
  dark: "#3571FF",
  darker: "#252733",
  primaryBlue: "#3471FF",
  primayRed: "#ea4335",
  green: "#59a385",
  background: "#FBFBFB",
  textColor: "#494949",
  backgroundColor: "#BFC5DA",
  blue:'#1F348B',
  borderColor:"#40B8B3",
  secondary:"#3169C8",
  headingColor:'#1F1F1F',
  buttonColor:createButtonLinearGradient("#00A19A","#4582E8","#2F7DFF"),
  mediumTeal:'#40B7B5',
  royalBlue:'#2F7DFF',
  azureBlue:'#327DFA'
};
// const SECONDARY = {
//   lighter: '',
//   light: '',
//   main: '',
//   dark: '',
//   darker: '',
// };
// const INFO = {
//   lighter: '',
//   light: '',
//   main: '',
//   dark: '',
//   darker: '',
// };
// const SUCCESS = {
//   lighter: '',
//   light: '',
//   main: '',
//   dark: '',
//   darker: '',
// };
const WARNING = {
  lighter: "#FEC400",
  light: "#FEC400",
  main: "#FEC400",
  dark: "#FEC400",
  darker: "#FEC400",
};
const ERROR = {
  lighter: '',
  light: '',
  main: '#FB104B',
  dark: '',
  darker: '',
};

const GREY = {
  0: "#FFFFFF",
  100: "#9FA2B4",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  500_8: createAlpha("#919EAB", 0.08),
  500_12: createAlpha("#919EAB", 0.12),
  500_16: createAlpha("#919EAB", 0.16),
  500_24: createAlpha("#919EAB", 0.24),
  500_32: createAlpha("#919EAB", 0.32),
  500_48: createAlpha("#919EAB", 0.48),
  500_56: createAlpha("#919EAB", 0.56),
  500_80: createAlpha("#919EAB", 0.8),
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  // info: createGradient(INFO.light, INFO.main),
  // success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const COMMON = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY, contrastText: "#fff" },
  // secondary: { ...SECONDARY, contrastText: '#fff' },
  // info: { ...INFO, contrastText: '#fff' },
  // success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: '#fff' },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const palette = {
  light: {
    ...COMMON,
    mode: "light",
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    background: { paper: "#E6E6EA", default: "#EAEAF3", neutral: GREY[200] },
    action: { active: GREY[600], ...COMMON.action },
    borderColor: {default: "#40B8B3"},
    // borderColor: { default: "#3169C8" },
    color: {default: "#E6E6EA"}
  },
  dark: {
    ...COMMON,
    mode: "dark",
    text: { primary: "#fff", secondary: GREY[500], disabled: GREY[600] },
    background: { paper: GREY[800], default: GREY[900], neutral: GREY[500_16] },
    action: { active: GREY[500], ...COMMON.action },
  },
};

export default palette;
